<template>

      <el-row>
          <h2>Filter/Search</h2>
          <el-row :gutter="24">
            <el-col :lg="6">
              Division:  <division-dropdown v-model="divisionId" :inputModel="divisionId"></division-dropdown>
            </el-col>
            <el-col :lg="6">
              Approval Role:  <role-dropdown v-model="approvalRoleId" :inputModel="approvalRoleId"></role-dropdown>
            </el-col>
            <el-col :lg="6">
              User:  <user-dropdown v-model="userId" :inputModel="userId" :approverOnly="true"></user-dropdown>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :lg="10">
              <el-button type="warning" class="searchBtn" @click="clear()">Clear Options</el-button>
            </el-col>
            <el-col :lg="2">
              <el-button type="primary" class="searchBtn" @click="showAll()">Show All</el-button>
            </el-col>
            <el-col :lg="3">
              <el-button type="primary" class="searchBtn" @click="search()">Search</el-button>
            </el-col>
            <el-col :span="3">
              <el-button type="primary" icon="el-icon-document" class="searchBtn" @click="exportReport()">Export List</el-button>
            </el-col>
          </el-row>

        <br/>
        <el-alert v-if="alertTitle !== ''"
          :title="alertTitle"
          :type="alertType"
          :description="callInfo"
          :closable="false"
          show-icon>
        </el-alert>
        <br />
        <el-col :span="24">
          <h3>Approval Roles and Users</h3>
          <transition name="panel">

            <div class="pea-panel .rules-panel">
              <el-table :data="authorizationUserRoles" class="allRulesTable" v-loading="tableLoading">
                <el-table-column prop="peaDivisionName" align="left"
                                 label="Division">
                </el-table-column>
                <el-table-column prop="roleName" align="left"
                                 label="Approval Role">
                </el-table-column>
                <el-table-column prop="userFullName" align="left"
                                 label="User">
                </el-table-column>
              </el-table>
              <el-pagination v-if="resultTotal > pageSize"
                             @current-change="fetchData"
                             :current-page.sync="currentPage"
                             :page-size="pageSize"
                             layout="total, prev, pager, next"
                             :total="resultTotal">
              </el-pagination>
            </div>
          </transition>
        </el-col>
      </el-row>
</template>
<script>
import helperMethods from '@/components/utility/helperMethods.js'
export default {
  name: 'viewPEAApprovalRolesAndUsers',
  data () {
    return {
      authorizationUserRoles: [],
      searchedAuthorizationUserRoles: [],
      callInfo: '',
      alertType: '',
      alertTitle: '',
      divisionId: '',
      userId: '',
      approvalRoleId: '',
      currentPage: 1,
      pageSize: 15,
      resultTotal: 0,
      tableLoading: true,
      exportFields: ['peaDivisionName', 'roleName', 'userFullName'],
      fieldOptions: [
        { label: 'Division', value: 'peaDivisionName' },
        { label: 'Role', value: 'roleName' },
        { label: 'User', value: 'userFullName' }
      ],
      csvData: ''
    }
  },
  computed: {
    titleRow () {
      var fields = this.exportFields.map(field => {
        var selectedField = this.fieldOptions.filter(option => {
          return field === option.value
        })
        return selectedField[0].label
      })
      return fields.join(',')
    }
  },
  methods: {
    fetchData: function () {
      this.search()
    },
    search () {
      this.tableLoading = true
      var tempDiv = this.divisionId
      var tempUser = this.userId
      var tempApproval = this.approvalRoleId
      if (this.divisionId === '' || this.divisionId === null) {
        tempDiv = 0
      }
      if (this.userId === '' || this.userId === null) {
        tempUser = 0
      }
      if (this.approvalRoleId === '' || this.approvalRoleId === null) {
        tempApproval = 0
      }
      var call = '/getActivePEAUserAuthorizationRolesByFilters/' + '?page=' + this.currentPage + '&pageSize=' + this.pageSize + '&divisionId=' + tempDiv + '&approvalRoleId=' + tempApproval + '&userId=' + tempUser
      this.$axios.get(call).then(response => {
        this.authorizationUserRoles = response.data.results
        this.resultTotal = response.data.totalRecords
        this.tableLoading = false
      }).catch(reject => {
        this.tableLoading = false
        this.tableData = null
        this.resultTotal = 0
        helperMethods.showNotification(this, 'Error retreiving Approval Role List', reject.body, 'error', 30000)
      })
    },
    exportReport () {
      this.GetAllSearchedResultsAtOnce().then(data => {
        let csvContent = ''
        csvContent += this.titleRow + '\r\n'
        let csvData = this.createCSVData()
        csvContent += csvData
        var element = document.createElement('a')
        element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(csvContent))
        element.setAttribute('download', 'PEA Approval Roles and Users.csv')
        element.style.display = 'none'
        document.body.appendChild(element)
        element.click()
        document.body.removeChild(element)
      }).catch(reject => {})
    },
    GetAllSearchedResultsAtOnce () {
      var call = '/getActivePEAUserAuthorizationRolesByFilters/' + '?page=1' + '&pageSize=' + this.resultTotal + '&divisionId=' + this.divisionId + '&approvalRoleId=' + this.approvalRoleId + '&userId=' + this.userId
      return new Promise((resolve, reject) => {
        this.$axios.get(call).then(response => {
          this.searchedAuthorizationUserRoles = response.data.results
          resolve(response)
        }).catch(response => {
          this.tableData = null
          this.resultTotal = 0
          helperMethods.showNotification(this, 'Error retreiving Approval Role List', response.body, 'error', 30000)
          reject(response)
        })
      })
    },
    createCSVData: function () {
      this.csvData = ''
      let row = ''
      const items = this.searchedAuthorizationUserRoles
      items.forEach(approver => {
        row = ''
        this.exportFields.forEach(field => {
          if (field === 'userFullName') {
            row += String(approver[field]).split(',').reverse().join(' ')
          } else {
            var replace2 = approver[field].toString().replace('–', '-')
            replace2 = replace2.toString().replace(',', ' ')
            if (replace2.split('"').length - 1 > 0) {
              row += '"' + replace2
            } else {
              row += '"' + replace2 + '"'
            }
          }
          row += ','
        })
        this.csvData += row + '\r\n'
      })
      return this.csvData
    },
    clear () {
      this.userId = ''
      this.divisionId = ''
      this.approvalRoleId = ''
      this.csvData = ''
      // this.fetchData()
    },
    showAll () {
      this.userId = ''
      this.divisionId = ''
      this.approvalRoleId = ''
      this.fetchData()
    },
    // spanLogicMethod ({ row, column, rowIndex, columnIndex }) {
    //  if (columnIndex === 2) {
    //    return {
    //      rowspan: 1,
    //      colspan: 2
    //    }
    //  } else {
    //    return {
    //      rowspan: 1,
    //      colspan: 1
    //    }
    //  }
    // },
    startUp () {
      this.fetchData()
    }
  },
  mounted () {
    this.startUp()
  }
}
</script>

<style scoped>
  h4 {
    margin-bottom: 20px;
  }

  .rules-panel {
    padding-bottom: 30px;
  }
</style>
<style>
  .allRulesTable tr:hover {
    cursor: default;
  }
  .searchBtn {
    float: right;
    margin-top: 20px;
  }
</style>
